import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import getBoxSizeString from 'components/helpers/getBoxSizeString';
import BodyText from 'components/widget/BodyText';
import WidgetContainer from 'components/widget/WidgetContainer';
import { FullWidthPaperContent } from 'components/Paper';
import ProductPrice from 'components/ProductPrice';
import ProductImageView from 'components/ProductImageView';
import Checkbox from 'components/Checkbox';
import Button from 'components/Button';

const Wrapper = styled.div`
  .topSection {
    margin-bottom: ${({ theme }) => theme.spacing * 3}px;
  }

  .formCta {
    padding: ${({ theme }) => theme.spacing * 2}px;
    > * {
      margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    }
  }

  .Checkbox {
    .checkboxUi{
      margin-right:1em;
    }
    p {
      margin-top: 0;
    }
  }
`;

const PriceWidget = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  h3{
    margin:0;
  }
`;

const OrderTopupsReviewView = ({
  className, selectedTopup, onSubmit, onCancel,
}) => {
  const classes = ['OrderTopupsReviewView'];
  if (className) classes.push(className);

  const [termsAcknowledged, setTermsAcknowledged] = React.useState(false);
  const [clinicalConfirmation, setClinicalConfirmation] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(selectedTopup);
  }

  function onTermsAcknowledged(d) {
    setTermsAcknowledged(d.target.checked);
  }
  const solution = selectedTopup.items.find((i) => i.kind === 'solution');

  return (
    <Wrapper className={classes.join(' ')}>
      <div className="topSection">
        <h1 className="no_margin_top">Order Top-ups</h1>
        <BodyText>Please check the details below before moving on.</BodyText>
      </div>
      <FullWidthPageContent as="form" onSubmit={handleSubmit}>
        <WidgetContainer noRoundedCorners>
          <FullWidthPaperContent className="section">
            <h4>Your package</h4>
            <PriceWidget>
              <BodyText>
                {getBoxSizeString({
                  boxSize: selectedTopup.boxSize,
                  quantity: selectedTopup.quantity,
                  numberOfEyes: selectedTopup.items.filter((i) => i.kind === 'lens').length,
                }, !!solution)}
              </BodyText>
              <h3>
                <ProductPrice
                  currency={selectedTopup.price.currency}
                  price={selectedTopup.price.price + ((solution && solution.price) || 0)}
                />
              </h3>
            </PriceWidget>
            <ProductImageView
              format="thumbnailAndText"
              items={selectedTopup.items}
            />
          </FullWidthPaperContent>
          <FullWidthPaperContent className="section">
            <h4>About your eye health</h4>
            <Checkbox onChange={(e) => setClinicalConfirmation(e.target.checked)}>
              <p>
                I confirm I am not experiencing any problems with my vision,
                eye health or contact lenses including discomfort or redness.
              </p>
              <p>Please contact your local store if you have any concerns.</p>
            </Checkbox>
          </FullWidthPaperContent>
          <FullWidthPaperContent className="section">
            <h4>About your payment</h4>
            <Checkbox onChange={onTermsAcknowledged}>
              I understand that the payment shown above will be debited in full
              from my nominated payment method within the next 10 days.
            </Checkbox>
          </FullWidthPaperContent>

          <div className="formCta">
            <Button
              disabled={!termsAcknowledged || !clinicalConfirmation}
              fullWidth
              type="submit"
              dataLayer={{ action: 'Top Up', label: `Confirm Order - ${selectedTopup.title}` }}
            >
              Order top-ups
            </Button>
            <Button inverse fullWidth type="button" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </WidgetContainer>
      </FullWidthPageContent>
    </Wrapper>
  );
};

OrderTopupsReviewView.displayName = 'OrderTopupsReviewView';

OrderTopupsReviewView.propTypes = {
  className: PropTypes.string,
  selectedTopup: PropTypes.shape({
    title: PropTypes.string,
    boxSize: PropTypes.number,
    quantity: PropTypes.number,
    price: PropTypes.shape({
      currency: PropTypes.string,
      price: PropTypes.number,
    }),
    items: PropTypes.arrayOf(PropTypes.shape({
      kind: PropTypes.oneOf(['lens', 'solution']),
    })).isRequired,
    solution: PropTypes.shape({}),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

OrderTopupsReviewView.defaultProps = {
  className: undefined,
};

export default OrderTopupsReviewView;
